import { createOutlet } from './Outlet';
export function last(outletDescriptor) {
    var last;
    return createOutlet({
        getCurrentValue: function () {
            var currentValue;
            try {
                currentValue = { value: outletDescriptor.getCurrentValue() };
                if (outletDescriptor.hasCurrentValue &&
                    !outletDescriptor.hasCurrentValue()) {
                    currentValue = undefined;
                }
            }
            catch (errorOrPromise) {
                if (!last ||
                    !errorOrPromise ||
                    typeof errorOrPromise.then !== 'function') {
                    throw errorOrPromise;
                }
            }
            if (currentValue) {
                last = currentValue;
            }
            // If last isn't available, createOutlet() will not use its value due
            // to the result of hasCurrentValue()
            return (last ? last.value : last);
        },
        hasCurrentValue: function () {
            // createOutlet() will only ever call this after calling `getCurrentValue`
            return last !== undefined;
        },
        subscribe: outletDescriptor.subscribe,
    });
}
//# sourceMappingURL=last.js.map